import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { Dropdown } from "primereact/dropdown";
import React from "react";
import { useEffect } from "react";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import Loader from "../../Components/Loader";
import { createAPIEndpoint, Endpoint } from "../../Services/RSECustomerService";
import storage from "../../Services/Storage";

const RSECustomerAllRecords = () => {
    const auth = storage.getLocal("user");
    const nav = useNavigate();

    const[loading,setLoading] = useState(false);
    const[resCust, setRseCust] = useState([]);

    const [statuses] = useState(["Accepted","Rejected","Pending"]);
    const GetRSECustList = async () => {
        setLoading(true);
        try {
            const response = await createAPIEndpoint().get(`${Endpoint.GetRSECustList}?CompId=${auth.CompId}`);
            setRseCust(response.data.Data);
        } catch (error) {
            console.log("error ", error);
        }finally{
            setLoading(false);
        }
    };
    const statusRowFilterTemplate = (options) => {
        return (
            <Dropdown value={options.value} options={statuses} onChange={(e) => options.filterApplyCallback(e.value)} placeholder="Select One" className="p-column-filter" showClear style={{ maxWidth: "12rem" }} />
        );
    };
    useEffect(()=>{
        GetRSECustList();
    },[]);
    const renderAction = (rowData) => {
        return (
            <>
                <div className="action-icon">
                    <div
                        className="d-inline"
                        data-toggle="tooltip"
                        data-placement="bottom"
                        title="View/Edit RSE Customer Details"
                    >
                        <button
                            className="grid-icon-img"
                            onClick={() => {
                                nav(
                                    `/masters/ruralserviceexpress/details?csdCode=${encodeURIComponent(rowData.CSD_CODE)}&partyCode=${encodeURIComponent(rowData.DEALER_CODE)}&partyId=${encodeURIComponent(rowData.PARTY_ID)}`
                                );
                            }}
                        >
                            <img
                                alt="InnoRise"
                                width="20px"
                                src={require("../../Assets/Images/ViewEdit.png")}
                            />
                        </button>
                    </div>
                </div>
            </>
        );
    };
    if(loading){
        return (<Loader/>);
    }else{
        return (
            <>
                <main>
                    <div className="row">
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            <h3 className="py-2">Rural Service Express</h3>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-12">
                            {/* <div className="text-end">
                                <Link to="/masters/rsecustomer/details">
                                    <button type="button" className="btn btn-primary">Add New</button>
                                </Link>
                            </div> */}
                        </div>
                    </div>

                    <div className="col-md-12 col-lg-12 col-sm-12">
                        <div className="DataTable">
                            <DataTable
                                value={resCust}
                                dataKey=''
                                paginator
                                rows={10}
                                filterDisplay="row"
                                scrollable
                                rowsPerPageOptions={[10, 25, 50]}
                                scrollHeight="80vh"
                                showGridlines
                                stripedRows
                                emptyMessage="No records found."
                                tableStyle={{ minWidth: "80rem" }}>
                                <Column field="CSD" header="CSD" filter filterMatchMode="contains" filterPlaceholder="Search Here..." style={{ minWidth: "15rem" }} />
                                <Column field="DEALER" header="RSE Customer" filter filterMatchMode="contains" filterPlaceholder="Search Here..." style={{ minWidth: "15rem" }} />
                                <Column field="DEALER_PID" header="RSE Unique Code" filter filterMatchMode="contains" filterPlaceholder="Search Here..." style={{ minWidth: "10rem" }} />
                                <Column field="PROCESS_STATUS" header="Status" showFilterMenu={false} filter filterElement={statusRowFilterTemplate} style={{ minWidth: "10rem" }} />
                                <Column field="REMARKS" header="Comment" style={{ minWidth: "10rem" }} />
                                <Column field={renderAction} header="Action" style={{ minWidth: "4rem" }} />
                            </DataTable>
                        </div>
                    </div>
                </main>
            </>
        );
    }
};

export default RSECustomerAllRecords;